import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row text-sm-center text-left" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = { class: "carousel__item" };
const _hoisted_4 = { class: "col-sm-10 col-12 offset-sm-1 offset-0 text-left p-3" };
const _hoisted_5 = { class: "row no-gutters" };
const _hoisted_6 = { class: "col-auto pl-3 pl-sm-0" };
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    class: "col-auto pl-3",
    style: { "display": "flex", "align-items": "center" }
};
const _hoisted_9 = { class: "row no-gutters" };
const _hoisted_10 = { class: "col-sm-10 col-12 pl-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slide = _resolveComponent("Slide");
    const _component_Pagination = _resolveComponent("Pagination");
    const _component_Navigation = _resolveComponent("Navigation");
    const _component_Carousel = _resolveComponent("Carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-12 simple" }, [
            _createElementVNode("h3", { class: "h2-responsive mb-5" }, [
                _createTextVNode(" Das sagen unsere Kunden über "),
                _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP")
            ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Carousel, {
                autoplay: 4000,
                "wrap-around": true
            }, {
                addons: _withCtx(() => [
                    _createVNode(_component_Pagination),
                    (!_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_Navigation, { key: 0 }, {
                            next: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "sliderButtonBox" }, [
                                        _createElementVNode("i", { class: "icon-arrow-next fc-brand_deep_blue font3" })
                                    ], -1)
                                ]))]),
                            prev: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createElementVNode("div", { class: "sliderButtonBox" }, [
                                        _createElementVNode("i", { class: "icon-arrow-prev fc-brand_deep_blue font3" })
                                    ], -1)
                                ]))]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("img", {
                                                    class: "",
                                                    alt: "Kunde",
                                                    loading: "lazy",
                                                    src: slide.img,
                                                    style: { "object-fit": "contain" }
                                                }, null, 8, _hoisted_7)
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("strong", null, _toDisplayString(slide.name), 1),
                                                _cache[0] || (_cache[0] = _createElementVNode("img", {
                                                    src: "/optimized/img?source=%2Fimages%2Fwertgarantie%2Fbg_symbol_slider.png&format=webp&max-width=1300",
                                                    alt: "Wertgarantie",
                                                    style: { "position": "absolute", "top": "0px", "left": "0px", "height": "120px" }
                                                }, null, -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-auto pl-3 pl-sm-0" }, [
                                                _createElementVNode("div", { style: { "width": "50px" } }, " ")
                                            ], -1)),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("p", null, _toDisplayString(slide.text), 1)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            })
        ])
    ]));
}
